import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Link } from 'react-router-dom';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import TrainingCertificationsModal from './TrainingCertificationsModal';
import TrainingCertificationsModalView from './TrainingCertificationsModalView';
import getLocale from '../../../i18n/getLocale';

class TrainingCertificationsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      date_start_str: this.props.training_data.date_start_str,
      date_finish_str: this.props.training_data.date_finish_str,
      certifications: [],
      certification_suppliers: [],
      certification_suppliers_modal: null,
      certification_id: null,
      certification_supplier_id: null,
      modal_props: false,
      training_certifications: [],
      staff_list: [],
      instructors_data: null,
      examiners_data: null,
      training_certification: {},
      training_certification_staffs: null,
      c_hours: null,
      updated: 0,
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.editModal = this.editModal.bind(this);
    this.viewModal = this.viewModal.bind(this);
    this.closeModalParent = this.closeModalParent.bind(this);
    this.closeModalViewParent = this.closeModalViewParent.bind(this);
    this.updateDataModal = this.updateDataModal.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleSelectChangePresence(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      if (event.value !== null) {
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/verificar/fornecedor/validade/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'error') {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            } else {
              self.props.handleAlert('', '', 'closed');
            }
          });
        });      
      }
    }
    this.setState(change);
  }
  
  handleSelectChangeCertification(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      if (event.value !== null) {
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/certificado/fornecedores/lista/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({certification_suppliers: responseJson.data});
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });      
      }
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && typeof newProps.training_data.name !== 'undefined' && Array.isArray(newProps.certifications) && Array.isArray(newProps.training_certifications) && Array.isArray(newProps.staff_list)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        name: newProps.training_data.name,
        training_id: newProps.training_data.id,
        date_start_str: newProps.training_data.date_start_str,
        date_finish_str: newProps.training_data.date_finish_str,
        code: newProps.training_data.code,
        revision: newProps.training_data.revision,
        observations: newProps.training_data.observations,
        certifications: newProps.certifications,
        training_certifications: newProps.training_certifications,
        staff_list: newProps.staff_list,
        loaded: 1,
      });
    }
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      training_id: this.state.training_id,
      date_start: this.state.date_start_str,
      date_finish: this.state.date_finish_str,
      certification_id: this.state.certification_id,
      certification_supplier_id: this.state.certification_supplier_id,
      presence_type: this.state.presence_type,
      c_hours: this.state.c_hours,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  updateDataModal (responseJson) {
    var header = this.setState({updated: 1});
    var self = this;
    Promise.resolve(header).then(function(value) {
      self.editModal(responseJson);
    });      
  }

  editModal (event) {
    if (this.state.updated == 0) {
      var training_certification_id = event.currentTarget.value;
      this.props.handleAlert('', '', 'open');     
    } else {
      var training_certification_id = event.data.training_certification_id;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/instrutores/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({instructors_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificado/examinadores/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({examiners_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificado/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({training_certification: responseJson.data});
        if (responseJson.status === 'success') {
          fetch(config.get('api') + '/certificado/fornecedores/lista/' + responseJson.data.certification_id , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              if (self.state.updated == 1) {
                self.props.handleAlert(event.message, event.status, 'open');
              } else {
                self.setState({modal_props: true, certification_suppliers_modal: responseJson.data, training_certification_id: training_certification_id});
                self.props.handleAlert('', '', 'closed');
              }
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          });
        } else {
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }); }); /* Certificado do treinamento */ }); /*  Examinadores do certificado */
    });      
  }

  viewModal (event) {
    if (this.state.updated == 0) {
      var training_certification_id = event.currentTarget.value;
      this.props.handleAlert('', '', 'open');     
    } else {
      var training_certification_id = event.data.training_certification_id;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/instrutores/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({instructors_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/treinamento/certificado/examinadores/' + training_certification_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({examiners_data: responseJson.data});
        }
      }).then(() => {
        self.setState({modal_props: true});
        self.props.handleAlert('', '', 'closed');
      }); /* Certificado do treinamento */ }); /*  Examinadores do certificado */
    });      
  }

  delete (event) {
    var training_certification_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabAulas.deletarAula);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/' + training_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }
  
  closeModalParent() {
    var responseJson = {
      status: 'success',
      message: this.locale.Treinamentos.EditarTreinamento.tabAulas.mensagemDadosAtualizadosComSucesso,
    };
    this.props.handleAlert('', '', 'open');
    this.setState({modal_props: false, updated: 0}, this.props.updateData(responseJson));
  }

  closeModalViewParent() {
    this.setState({modal_props: false, updated: 0});
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tituloAdicionarCertificado}</h3>
  <hr/>
  <form onSubmit={this.add}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.Certificado}:</label>
          <Select
            className="form-field-name"
            name="certification_id"
            value={this.state.certification_id}
            searchable={true}
            placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.placeholder.SelecionarCertificado}
            onChange={this.handleSelectChangeCertification.bind(this, 'certification_id')}
            options={this.state.certifications}
            required
          />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.Fornecedor}:</label>
          <Select
            className="form-field-name"
            name="certification_supplier_id"
            value={this.state.certification_supplier_id}
            searchable={true}
            placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.placeholder.SelecionarFornecedor}
            onChange={this.handleSelectChangeSupplier.bind(this, 'certification_supplier_id')}
            options={this.state.certification_suppliers}
            required
          />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.DataDeInicio}:</label>
          <InputMask value={this.state.date_start_str}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start_str')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.placeholder.DataDeInicio} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.DataDeTermino}:</label>
          <InputMask value={this.state.date_finish_str}  maskChar={null} name="date_finish_str " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish_str')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.placeholder.DataDeTermino} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.Periodo}:</label>
          <input value={this.state.c_hours} name="date_start" className="form-control" onChange={this.handleChange.bind(this, 'c_hours')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.placeholder.PeriodoDaAula} />
        </div>
      </div>
      {self.props.status === 1 || self.props.status === 3 ? 
        <div className="col-md-6">
          <div className="form-group">
            <label>{this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.TipoDeModalidade}:</label>
            <Select
              className="form-field-name"
              name="presence_type"
              value={this.state.presence_type}
              searchable={true}
              placeholder={this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.placeholder.SelecionarTipoDeModalidade}
              onChange={this.handleSelectChangePresence.bind(this, 'presence_type')}
              options={[
              {value: "presencial", label: this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.opcoesTipoDeModalidade.Presencial},
              {value: "ead", label: this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.opcoesTipoDeModalidade.EAD}
              ]}
              required
            />
          </div>
        </div>
        : ""
      }
    </div>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Treinamentos.EditarTreinamento.tabAulas.formularioAdicionarCertificado.botaoAdicionarCertificado}</button>
  </form>
  <hr/>
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tituloListaDeCertificados}</h3>
  <hr/>
  <table className="table table-bordered table-hover">
    <thead>
      <tr>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Certificado}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Fornecedor}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Cidade}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Inicio}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Fim}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Modalidade}</th>
        <th className="text-center">{this.locale.Treinamentos.EditarTreinamento.tabAulas.tabelaListaDeCertificados.Acoes}</th>
      </tr>
    </thead>
    <tbody id="training-certification-staffs">
      {Object.keys(self.state.training_certifications).map(function(k) {
        return (
          <tr>
            <td className="text-center">{self.state.training_certifications[k].certification_name}</td>
            <td className="text-center">{self.state.training_certifications[k].supplier_name}</td>
            <td className="text-center">{self.state.training_certifications[k].city}</td>
            <td className="text-center">{self.state.training_certifications[k].date_start_str}</td>
            <td className="text-center">{self.state.training_certifications[k].date_finish_str}</td>
            <td className="text-center">{self.state.training_certifications[k].presence_type_str}</td>
            <td className="col-md-1 text-center">
              {(self.props.status === 1 || self.props.status === 3) ? 
                <div className="btn-group">
                  <button className="btn btn-primary btn-sm" value={self.state.training_certifications[k].id} onClick={self.editModal}>
                    <i className="fa fa-fw fa-pencil"></i>
                  </button>
                  <button className="btn btn-sm btn-danger" value={self.state.training_certifications[k].id} onClick={self.delete}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </div>
              :
                  <button className="btn btn-info btn-sm" value={self.state.training_certifications[k].id} onClick={self.viewModal}>
                    <i className="fa fa-fw fa-eye"></i>
                  </button>
              }
              </td>
          </tr>
        );
      })}
    </tbody>
  </table>
  {(self.props.status === 1 || self.props.status === 3) ? 
    <TrainingCertificationsModal handleAlert={this.props.handleAlert} staff_list={this.props.staff_list} certifications={this.props.certifications} instructors_data={this.state.instructors_data} examiners_data={this.state.examiners_data} training_certification={this.state.training_certification} training_certification_id={this.state.training_certification_id} certification_suppliers_modal={this.state.certification_suppliers_modal} modal_props={this.state.modal_props} updateData={this.props.updateData} closeModalParent={this.closeModalParent} updateDataModal={this.updateDataModal} status={self.props.status} date_start_str={this.state.date_start_str} date_finish_str={this.state.date_finish_str} />
  :
    <TrainingCertificationsModalView instructors_data={this.state.instructors_data} examiners_data={this.state.examiners_data} modal_props={this.state.modal_props} closeModalViewParent={this.closeModalViewParent} />
  }
</div>
    );
  }
}

export default TrainingCertificationsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationsTab.js